export default {
  Title: 'Tham số báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  DisplayDataFromPayment: 'Hiển thị số liệu của cơ quan thanh toán vốn',
  Comment_Recommend: 'Nhận xét, kiến nghị',
  CommentContent: 'Nhận xét về việc chấp hành các quy định của nhà nước liên quan đến thanh toán, quyết toán',
  ExplainContent: 'Giải thích nguyên nhân chênh lệch số liệu (nếu có)',
  RecommendContent: 'Kiến nghị',
};
